import { render, staticRenderFns } from "./LabelRIcon.vue?vue&type=template&id=6e91e8a1&"
import script from "./LabelRIcon.vue?vue&type=script&lang=js&"
export * from "./LabelRIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports